import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import axios, { apiBaseUrl } from "../../api/axios";

const BulkUploadModal = ({ onClose }) => {
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState([]);
    const [message, setMessage] = useState('');

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        // Preview CSV content (optional)
        Papa.parse(selectedFile, {
            header: true,
            complete: (results) => {
                setPreview(results.data.slice(0, 5));  // Preview first 5 rows
            }
        });
    };

    const handleUpload = async () => {
        if (!file) {
            setMessage("Please select a CSV file before uploading.");
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        try {
            const res = await axios.post('/customers/bulk-upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setMessage(res.data.message + (res.data.skipped_duplicates ? ` | Skipped Duplicates: ${res.data.skipped_duplicates}` : ''));
            onClose();
        } catch (err) {
            setMessage("Upload failed: " + (err.response?.data?.error || err.message));
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
                <h2 className="text-lg font-semibold mb-4">Bulk Customer CSV Upload</h2>

                <input type="file" accept=".csv" onChange={handleFileChange} className="mb-4" />

                <a
                    href={`${apiBaseUrl}/templates/customers-bulk-template`}
                    download
                    className="text-blue-600 underline text-sm mb-3 inline-block"
                >
                    📥 Download CSV Template
                </a>

                {preview.length > 0 && (
                    <div className="overflow-x-auto text-sm max-h-64 overflow-y-auto mb-4 border">
                        <table className="table-auto w-full">
                            <thead>
                                <tr>
                                    {Object.keys(preview[0]).map((key) => (
                                        <th key={key} className="border px-2 py-1 bg-gray-100">{key}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {preview.map((row, idx) => (
                                    <tr key={idx}>
                                        {Object.values(row).map((val, i) => (
                                            <td key={i} className="border px-2 py-1">{val}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {message && <p className="text-sm text-center text-blue-600 mb-3">{message}</p>}

                <div className="flex justify-end gap-4">
                    <button className="bg-gray-500 text-white px-4 py-2 rounded" onClick={onClose}>Cancel</button>
                    <button className="bg-green-600 text-white px-4 py-2 rounded" onClick={handleUpload}>Upload</button>
                </div>
            </div>
        </div>
    );
};
export default BulkUploadModal;